import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Table,
  Divider,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { Auth } from "_helpers";
import { companyService, jobService } from "_services";
import TabMenu from "./TabMenu";

function Outcome({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [item, setItem] = useState({});
  const [stockReceipts, setStockReceipts] = useState([]);

  useEffect(() => {
    getItem();
    getStockReceiptsAgainstJob();
  }, []);

  const getItem = () => {
    jobService
      .getById(id)
      .then((x) => {
        setIsLoading(false);
        setItem(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getStockReceiptsAgainstJob = () => {
    jobService
      .getOutcome(id)
      .then((x) => {
        setIsLoading(false);
        setStockReceipts(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    return buttons;
  };

  const getStockReceiptColumns = () => {
    const lineColumns = [];
    lineColumns.push({
      title: "Receipt Number",
      dataIndex: "receiptNumber",
      key: "receiptNumber",
    });
    lineColumns.push({
      title: "Receipt Date",
      dataIndex: "receivedDate",
      key: "receivedDate",
    });
    lineColumns.push({
      title: "Task Code",
      dataIndex: "taskCode",
      key: "taskCode",
    });
    lineColumns.push({
      title: "Product HS.Code",
      dataIndex: "stockTypeCode",
      key: "stockTypeCode",
    });
    lineColumns.push({
      title: "Description",
      dataIndex: "stockTypeName",
      key: "stockTypeName",
    });
    lineColumns.push({
      title: "Received Quantity",
      dataIndex: "itemsReceived",
      key: "itemsReceived",
    });

    return lineColumns;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/jobs">Job Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`}>Job : {item.code}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <TabMenu menu="outcomes" id={id} />
          <Table
            bordered
            rowKey="receiptId"
            size="small"
            loading={isLoading}
            pagination={false}
            columns={getStockReceiptColumns()}
            dataSource={stockReceipts}
          />
        </Page>
      </PageHeader>
    </div>
  );
}

export default Outcome;
